import { Layout, Menu, Breadcrumb, Button, Divider, Select, Drawer, Tooltip } from 'antd';
import AppFooter from "./AppFooter";

import './layout.css'
import { LocalStorageService } from "../../../service/local-storage-service";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import Flex from "../../Flex";
import Logo from "./Logo";
import ProfileDropdown from "./ProfileDropdown";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { useState } from "react";

import { PERMISSIONS, useUser } from "../../../context/UserContext";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import NotificationMenu from "../../../../app/notification-menu";
import ThemeToggle from "./ThemeToggle";
import DarkThemeAnnouncement from "./DarkThemeAnnouncement";
import { useIsSmallScreen } from "../../../utils/useMediaQuery";
import buildMenuItems, { findSelectedKey } from "./menuItems";

const { Header } = Layout;

export default function MainLayout({ children }) {
    const isSmallScreen = useIsSmallScreen(992);
    const { t } = useTranslation();
    const history = useHistory();
    // window.location.pathname DEĞİL: MainLayout iç Switch'in dışında duruyor, sayfa
    // değişince yeniden render olmuyordu ve seçili sekme ilk açılan sayfada donup kalıyordu
    // (her yerde "Çekimler" seçili görünüyordu). useLocation rota değişimine abone olur.
    const { pathname } = useLocation();
    const { hasPermission, showDashboard, user } = useUser()
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Menü tanımı tek yerde: core/components/layout/main-layout/menuItems.js
    const menuItems = buildMenuItems({ t, hasPermission, showDashboard, PERMISSIONS });
    const selectedKey = findSelectedKey(menuItems, pathname);
    const selectedKeys = selectedKey ? [selectedKey] : [];

    // Merkezi navigasyon.
    // - Sol tık (normal): normal geçiş.
    // - Orta tık / Ctrl (yeni sekmede aç): tarayıcıda yeni sekme.
    const appNavigate = (path, opts = {}) => {
        if (opts.newTab) {
            window.open(path, '_blank')
        } else {
            history.push(path)
        }
    }

    const onClick = (item) => {
        const e = item?.domEvent
        const newTab = !!(e && (e.ctrlKey || e.metaKey))  // Ctrl/Cmd + tık => yeni sekme
        appNavigate(item.key, { newTab })
        setMobileMenuOpen(false)
    }

    // Menüde orta tık => "yeni sekmede aç" (config'e göre uygulama içi / tarayıcı)
    const handleAux = (e) => {
        if (e.button !== 1) return
        const el = e.target.closest && e.target.closest('[data-menu-id]')
        if (!el) return
        const id = el.getAttribute('data-menu-id') || ''
        const slash = id.indexOf('/')
        if (slash === -1) return
        e.preventDefault()
        appNavigate(id.slice(slash), { newTab: true })
    }

    return (
        <Layout>
            {
                isSmallScreen && (
                    <>
                        <Header id={'site-header'} style={{ position: 'fixed', zIndex: 100, width: '100%', height: 64, backgroundColor: 'var(--brand)', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                            <Flex alignItems={'center'} justifyContent={'space-between'} style={{ width: '100%', padding: '0 8px' }}>
                                <Button
                                    type="text"
                                    icon={<MenuOutlined style={{ fontSize: 20, color: '#fff' }} />}
                                    onClick={() => setMobileMenuOpen(true)}
                                    style={{ width: 48, height: 48 }}
                                />
                                <Logo />
                                <Flex alignItems={'center'} gap={4}>
                                    <ThemeToggle />
                                    <NotificationMenu />
                                    <ProfileDropdown />
                                </Flex>
                            </Flex>
                        </Header>
                        <Drawer
                            title={<Logo />}
                            className="nav-drawer"
                            placement="left"
                            onClose={() => setMobileMenuOpen(false)}
                            open={mobileMenuOpen}
                            width="min(86vw, 320px)"
                            styles={{ body: { padding: 0 } }}
                            closeIcon={<CloseOutlined />}
                        >
                            <Menu
                                onClick={onClick}
                                mode="inline"
                                selectedKeys={selectedKeys}
                                className="mobile-nav"
                                style={{ border: 'none' }}
                                items={menuItems}
                            />
                        </Drawer>
                    </>
                )
            }
            {
                !isSmallScreen && (
                    <Header id={'site-header'} style={{ position: 'fixed', zIndex: 100, width: '100%', height: 64, backgroundColor: 'var(--brand)', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                        <Flex alignItems={'center'}>
                            <Logo />
                            <span
                                onAuxClick={handleAux}
                                onMouseDown={(e) => { if (e.button === 1) e.preventDefault() }}
                                style={{ flex: 1, minWidth: 0, display: 'flex' }}
                            >
                            <Menu
                                style={{ marginLeft: 16, flex: 1, backgroundColor: 'transparent', borderBottom: 'none' }}
                                onClick={onClick}
                                theme="dark"
                                mode="horizontal"
                                selectedKeys={selectedKeys}
                                items={menuItems}
                            />
                            </span>
                            <ThemeToggle />
                            <NotificationMenu />
                            <ProfileDropdown />
                        </Flex>
                    </Header>
                )
            }
            <Layout className="site-layout">
                {children}
            </Layout>
            {/* Footer site-layout'un DIŞINDA: sayfalar Sider kullanıyor, antd o Layout'u yatay eksene
                çeviriyor (.ant-layout-has-sider) ve içeride kalan footer içeriğin sağına savruluyor. */}
            <AppFooter />
            {/* Header dallarının dışında: dar/geniş ekran geçişinde yeniden kurulup kapanmasın. */}
            <DarkThemeAnnouncement />
        </Layout>
    )
}
